export default function initCalculator() {
    const btnsCars = document.querySelector("#btns-cars");
    const btnsAreas = document.querySelector("#btns-areas");
    const btnsMonths = document.querySelector("#btns-months");
    const priceFieldRegular = document.querySelector("#price-regular");
    const priceFieldCalculated = document.querySelector("#price-calculated");
    const priceFieldDiscount = document.querySelector("#price-discount");
    const calcButton = document.querySelector("section.calculate button");

    if (
        !btnsCars ||
        !btnsAreas ||
        !btnsMonths ||
        !priceFieldRegular ||
        !priceFieldCalculated ||
        !priceFieldDiscount
    ) return;

    // 🔹 базові ціни за площу (м2/м3)
    const basePrices = {
        sm01: 800,
        sm1_5: 1200,
        sm02: 1500,
        sm03: 2100,
        sm04: 2800,
        sm05: 3500,
        sm06: 4200,
        sm08: 5600,
        sm10: 7000,
        sm12: 8400
    };

    // 🔹 мапа відповідності кнопок до ключів у basePrices
    const normalizeKey = (key) => key.replace('.', '_');

    // 🔹 підпис термінів для кнопок
    const monthLabels = {
        mth1_5: '1-5 міс',
        mth6_11: '6-11 міс',
        mth12: '12+ міс'
    };

    function recalculatePrice() {
        const activeArea = btnsAreas.querySelector(".button.active");
        const activeMonth = btnsMonths.querySelector(".button.active");

        if (!activeArea || !activeMonth) return;

        const areaKey = normalizeKey(activeArea.dataset.squares);
        const monthKey = activeMonth.dataset.months;

        // Базова ціна
        const base = basePrices[areaKey] || 0;

        // Знижки
        let discountPercent = 0;
        if (monthKey === 'mth6_11') discountPercent = 5;   // 6–11 міс
        if (monthKey === 'mth12') discountPercent = 10;  // 12+ міс

        const discountValue = Math.round(base * (discountPercent / 100));
        const calculated = base - discountValue;

        // Вивід
        priceFieldRegular.innerHTML = `${base} <span>грн</span>`;
        priceFieldCalculated.innerHTML = `${calculated} <span>грн</span>`;
        priceFieldDiscount.innerHTML = `${discountValue} <span>грн</span>`;

        // Оновлюємо текст кнопки
        const valueAreaEl = document.querySelector(".area-value");
        const valueTermEl = document.querySelector(".term-value");

        if (valueAreaEl && valueTermEl) {
            valueAreaEl.innerHTML = activeArea.innerHTML;
            valueTermEl.textContent = monthLabels[monthKey] || '';
        }

        if (calcButton) {
            calcButton.dataset.order = `Забронювати бокс ${activeArea.textContent} на ${monthLabels[monthKey]}`;
        }
    }

    // 🔹 вибір розміру боксу
    btnsAreas.addEventListener("click", (e) => {
        const btn = e.target.closest(".button");
        if (!btn) return;

        btnsAreas.querySelector(".active")?.classList.remove("active");
        btn.classList.add("active");

        const areaVal = btn.dataset.squares;
        console.log(areaVal);
        btnsCars.querySelectorAll(".car").forEach((car) => {
            const raw = car.getAttribute("data-squaresall") || "";
            const list = raw.split(",").map((s) => s.trim()).filter(Boolean);
            car.classList.toggle("active", list.includes(areaVal));
        });

        recalculatePrice();
    });

    // 🔹 вибір терміну оренди
    btnsMonths.addEventListener("click", (e) => {
        const btn = e.target.closest(".button");
        if (!btn) return;

        btnsMonths.querySelector(".active")?.classList.remove("active");
        btn.classList.add("active");

        recalculatePrice();
    });

    // 🔹 вибір авто
    btnsCars.addEventListener("click", (e) => {
        const car = e.target.closest(".car");
        if (!car) return;

        btnsCars.querySelector(".active")?.classList.remove("active");
        car.classList.add("active");

        const squares = car.dataset.squares;

        btnsAreas.querySelector(".active")?.classList.remove("active");
        btnsAreas.querySelector(`[data-squares="${squares}"]`)?.classList.add("active");

        recalculatePrice();
    });

    // 🔹 запуск при завантаженні
    recalculatePrice();
}
